import { render, staticRenderFns } from "./IdentityCardDoc.vue?vue&type=template&id=6106d67a&scoped=true&"
import script from "./IdentityCardDoc.vue?vue&type=script&lang=js&"
export * from "./IdentityCardDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106d67a",
  null
  
)

export default component.exports